import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './pages/Login';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import UserList from './pages/UserList';
import UserForm from './pages/UserForm';
import MainLayout from './components/layout/MainLayout';
import MaterialList from './pages/MaterialList';
import MaterialForm from './pages/MaterialForm';
import LibraryList from './pages/LibraryList';
import LibraryForm from './pages/LibraryForm';
import Profile from './pages/Profile';

// Componentes temporários para rotas que ainda não têm páginas implementadas
const Publicacoes = () => (
  <MainLayout>
    <div className="mb-8">
      <h1 className="text-2xl md:text-3xl font-bold text-white font-raleway mb-2">
        <span className="text-vermelho-claro">Publicações</span>
      </h1>
      <p className="text-gray-300">
        Gerenciamento de publicações e bibliotecas de conteúdo.
      </p>
    </div>
    <div className="bg-gray-900/50 p-8 rounded-lg text-center">
      <h2 className="text-xl text-gray-300 mb-2">Página em desenvolvimento</h2>
      <p className="text-gray-400">
        Esta funcionalidade está sendo implementada e estará disponível em breve.
      </p>
    </div>
  </MainLayout>
);

const Permissoes = () => (
  <MainLayout>
    <div className="mb-8">
      <h1 className="text-2xl md:text-3xl font-bold text-white font-raleway mb-2">
        Gerenciar <span className="text-vermelho-claro">Permissões</span>
      </h1>
      <p className="text-gray-300">
        Controle de acesso aos materiais por usuário.
      </p>
    </div>
    <div className="bg-gray-900/50 p-8 rounded-lg text-center">
      <h2 className="text-xl text-gray-300 mb-2">Página em desenvolvimento</h2>
      <p className="text-gray-400">
        Esta funcionalidade está sendo implementada e estará disponível em breve.
      </p>
    </div>
  </MainLayout>
);

const NotFound = () => (
  <MainLayout>
    <div className="flex flex-col items-center justify-center py-12">
      <h1 className="text-4xl font-bold text-vermelho-claro mb-4">404</h1>
      <h2 className="text-2xl font-bold text-white mb-4">Página não encontrada</h2>
      <p className="text-gray-300 mb-6 text-center">
        A página que você está procurando não existe ou foi movida.
      </p>
    </div>
  </MainLayout>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Rota pública - Login */}
          <Route path="/login" element={<Login />} />
          
          {/* Rota padrão - redireciona para login */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          
          {/* Rotas protegidas para usuários comuns */}
          <Route element={<ProtectedRoute />}>
            <Route path="/home" element={<Home />} />
            <Route path="/perfil" element={<Profile />} />
          </Route>
          
          {/* Rotas protegidas apenas para administradores */}
          <Route element={<ProtectedRoute adminOnly />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/usuarios" element={<UserList />} />
            <Route path="/usuarios/novo" element={<UserForm />} />
            <Route path="/usuarios/:id" element={<UserForm />} />
            <Route path="/materiais" element={<MaterialList />} />
            <Route path="/materiais/novo" element={<MaterialForm />} />
            <Route path="/materiais/:id" element={<MaterialForm />} />
            <Route path="/bibliotecas" element={<LibraryList />} />
            <Route path="/bibliotecas/nova" element={<LibraryForm />} />
            <Route path="/bibliotecas/:id" element={<LibraryForm />} />
            <Route path="/permissoes" element={<Permissoes />} />
          </Route>
          
          {/* Rota para página não encontrada */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
